import { render, staticRenderFns } from "./ListMenus.vue?vue&type=template&id=41b5b236&"
import script from "./ListMenus.vue?vue&type=script&lang=js&"
export * from "./ListMenus.vue?vue&type=script&lang=js&"
import style0 from "./ListMenus.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports